import { ca } from '@cian/analytics';

export function trackBankClick(url: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'click_bank_logo',
    label: url,
    useLastProducts: true,
  });
}
